import { makeStyles, useTheme } from "@seahorse/ui";
import { useMemo } from "react";


function pipSizeForPair(pair: string) {
  // Common FX convention: JPY pairs pip = 0.01, otherwise 0.0001
  return pair.toUpperCase().includes("JPY") ? 0.01 : 0.0001;
}
type CoHedgerHeaderProps = {
  currencyPair: string;
  assetType: string;
  executionType: string;
  expirationDate?: string | null
};

const useHeaderStyles = makeStyles((theme: any) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 0,
    backgroundColor: theme.globallink.colors.DarkGrey[500],
    padding: "10px 10px 8px 10px",
  },
  row: {
    display: "flex",
    flexWrap: "wrap",
    gap: 10,
    alignItems: "center",
  },
  chip: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 10px",
    borderRadius: 999,
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.09)",
    color: "#E0E0E0",
    fontSize: 13,
    lineHeight: "16px",
    whiteSpace: "nowrap",
  },
  key: { opacity: 0.7 },
  value: { fontWeight: 700 },

  right: {
    marginLeft: "auto",
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    justifyContent: "flex-end",
  },
}));

export function CoHedgerHeaderHeader({
  currencyPair,
  assetType,
  executionType,
  expirationDate
}: CoHedgerHeaderProps) {

  const theme = useTheme();
  const classes: any = useHeaderStyles({ theme });
  const pipSize = useMemo(() => pipSizeForPair(currencyPair), [currencyPair]);



  return (
    <div className={classes.header}>
      <div className={classes.row}>

        {/* Currency Pair */}
        <span className={classes.chip}>
          <span className={classes.key}>Pair</span>
          <span className={classes.value}>{currencyPair}</span>
        </span>

        {/* Asset Type */}
        <span className={classes.chip}>
          <span className={classes.key}>Asset</span>
          <span className={classes.value}>{assetType}</span>
        </span>

        {/* Execution Type */}
        <span className={classes.chip}>
          <span className={classes.key}>Execution</span>
          <span className={classes.value}>{executionType}</span>
        </span>
        {/* Expiration */}
        <span className={classes.chip}>
          <span className={classes.key}>Expiration</span>
          <span className={classes.value}>{expirationDate}</span>
        </span>
        {/* Pip Size (nice trader UX) */}
        {/* <span className={classes.chip}>
          <span className={classes.key}>Pip Size</span>
          <span className={classes.value}>{pipSize}</span>
        </span> */}

      </div>
    </div>
  );
}
